import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LEAD_TYPES } from "../services/leadEmail";
import { submitLegacyLead } from "../services/legacyLeadSubmission";

function PumaGenE() {
  const navigate = useNavigate();

  const form = useForm();
  const { register, handleSubmit, formState } = form;
  const { errors } = formState;

  const marketingCampaign = async (data, slug) => {
    try {
      await submitLegacyLead({
        collectionName: slug,
        formData: data,
        firestoreData: {
          name: data.name ?? "",
          email: data.email ?? "",
          phone: data.phone ?? "",
          dealership: data.dealership ?? "",
          text: "",
          model: "Puma Gen-E",
        },
        leadPayload: {
          type: LEAD_TYPES.CAMPAIGN_OFFER,
          vehicle: {
            model: "Puma Gen-E",
          },
          campaign: {
            slug,
          },
          title: "pumaGenE",
          message: "Запитване за Puma Gen-E",
        },
      });

      navigate("/thank-you-testdrive");
    } catch (error) {
      console.error("Грешка при запис в Firebase:", error);
    }
  };

  const renderContactForm = () => {
    const slug = "puma-gen-e";

    return (
      <form
        onSubmit={handleSubmit((data) => marketingCampaign(data, slug))}
        id="templateCampaignForm"
        className="px-8 py-16 lg:px-48"
        noValidate
      >
        <h2 className="text-xl tracking-wider text-center uppercase text-fordBlue">
          Поискай оферта
        </h2>

        {/* Име */}
        <div className="mt-8">
          <label htmlFor="name" className="text-gray-500">
            Име
          </label>
          <input
            type="text"
            id="name"
            name="name"
            {...register("name", {
              required: {
                value: true,
                message: "Моля, въведете Вашето име",
              },
            })}
          />
          <p className="text-red-500">{errors.name?.message}</p>
        </div>

        {/* Имейл */}
        <div className="mt-4">
          <label htmlFor="email" className="text-gray-500">
            Имейл
          </label>
          <input
            type="email"
            id="email"
            name="email"
            {...register("email", {
              required: {
                value: true,
                message: "Моля, въведете имейл-адрес",
              },
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: "Невалиден имейл-адрес",
              },
            })}
          />
          <p className="text-red-500">{errors.email?.message}</p>
        </div>

        {/* Телефон */}
        <div className="mt-4">
          <label htmlFor="phone" className="text-gray-500">
            Телефон
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            {...register("phone", {
              required: {
                value: true,
                message: "Моля, въведете телефонен номер",
              },
              pattern: {
                value:
                  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
                message: "Невалиден телефонен номер",
              },
            })}
          />
          <p className="text-red-500">{errors.phone?.message}</p>
        </div>

        <div className="mt-4">
          <label htmlFor="dealership" className="text-gray-500">
            Предпочитано представителство
          </label>
          <select
            name="dealership"
            id="dealership"
            {...register("dealership", {
              required: {
                value: true,
                message: "Моля, изберете представителство",
              },
            })}
          >
            <option value="" disabled>
              Моля, изберете
            </option>
            <option value="liulin2@motopfohe.bg">София Люлин</option>
            <option value="mladost@motopfohe.bg">София Младост</option>
            <option value="blagoevgrad@motopfohe.bg">Благоевград</option>
            <option value="burgas@motopfohe.bg">Бургас</option>
            <option value="varna@motopfohe.bg">Варна</option>
            <option value="velikotarnovo@motopfohe.bg">Велико Търново</option>
            <option value="gabrovo@motopfohe.bg">Габрово</option>
            <option value="dobrich@motopfohe.bg">Добрич</option>
            <option value="montana@motopfohe.bg">Монтана</option>
            <option value="pleven@motopfohe.bg">Плевен</option>
            <option value="plovdiv@motopfohe.bg">Пловдив</option>
            <option value="russe@motopfohe.bg">Русе</option>
            <option value="starazagora@motopfohe.bg">Стара Загора</option>
            <option value="smolyan@motopfohe.bg">Смолян</option>
            <option value="forsh@motopfohe.bg">Шумен</option>
          </select>
          <p className="text-red-500">{errors.dealership?.message}</p>
        </div>

        {/* Скрито поле за заглавие на кампанията */}
        <input type="hidden" name="title" value="pumaGenE" />

        <button
          type="submit"
          className="px-16 py-2 mx-auto mt-8 text-white border rounded-full bg-fordBlue"
        >
          Изпрати
        </button>
      </form>
    );
  };

  return (
    <>
      <section className="relative w-full overflow-hidden">
        {/* Мобилна снимка */}
        <img
          src="/images/puma-gen-e/Ford-Puma-Gen-E-Hero-Mobile.jpg"
          alt="Ford Puma Gen-E mobile"
          className="block object-cover w-full h-full md:hidden"
        />

        {/* Десктоп снимка */}
        <img
          src="/images/puma-gen-e/Ford-Puma-Gen-E-Hero-Desktop.jpg"
          alt="Ford Puma Gen-E desktop"
          className="hidden object-cover w-full h-full md:block"
        />

        {/* Маска само за десктоп */}
        <div className="absolute inset-0 z-10 hidden md:block bg-gradient-to-b from-black/40 to-transparent" />

        {/* Overlay текст */}
        <div className="absolute inset-0 z-20 flex items-end justify-center px-6 pb-2 text-center md:px-12 md:items-start md:justify-start md:text-left md:pt-12 md:pb-0">
          <div className="text-white drop-shadow-md">
            <h1 className="text-2xl font-bold leading-tight md:text-5xl">
              Новата изцяло електрическа <br className="hidden md:inline" />
              Puma Gen-E
            </h1>
            <p className="mt-2 text-lg font-medium md:text-2xl">
              Сега на невероятна цена от <strong>57 700лв. с ДДС</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-10 bg-white md:py-16">
        <div className="flex justify-center gap-8">
          <a
            href="#poiskayOferta"
            className="inline-block px-6 py-3 text-lg tracking-widest text-white transition rounded-full bg-fordBlue md:text-xl hover:bg-fordLight"
          >
            Заяви оферта
          </a>
          <a
            href="https://sale.ford.bg/?model=Puma+Gen-E"
            className="inline-block px-6 py-3 text-lg tracking-widest text-white transition rounded-full bg-fordBlue md:text-xl hover:bg-fordLight"
          >
            Виж налични автомобили
          </a>
        </div>
      </section>

      <section className="w-full aspect-video">
        <div className="w-full aspect-video">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/sA1BHbkdf-I?autoplay=1&mute=1&controls=0&rel=0&playsinline=1&loop=1&playlist=sA1BHbkdf-I"
            title="Puma Gen-E видео 1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      <section className="w-full py-24 bg-white">
        <div className="grid grid-cols-1 gap-8 px-6 mx-auto text-left md:grid-cols-3">
          {/* Колона 1 */}
          <div>
            <p className="text-2xl text-fordLight">Пробег (комбиниран)</p>
            <p className="mt-4 tracking-wider text-7xl font-fordBold text-fordBlue">
              376 <span className="text-4xl font-fordRegular">km</span>
            </p>
          </div>
          {/* Колона 2 */}
          <div>
            <p className="text-2xl text-fordLight">
              Бързо зареждане ot 10% до 80%
            </p>
            <p className="mt-4 tracking-wider text-7xl font-fordBold text-fordBlue">
              23 <span className="text-4xl font-fordRegular">min</span>
            </p>
          </div>
          {/* Колона 3 */}
          <div>
            <p className="text-2xl text-fordLight">
              Комбиниран разход на енергия
            </p>
            <p className="mt-4 tracking-wider text-7xl font-fordBold text-fordBlue">
              13.1 <span className="text-4xl font-fordRegular">kWh/100km</span>
            </p>
          </div>
        </div>
      </section>

      <section className="p-16 tracking-wider bg-gray-100 text-fordBlue">
        <h3 className="font-fordBold">
          Енергичен и електрически – новият изцяло електрически Puma Gen-E®
        </h3>
        <p>
          Изцяло електрическият SUV, създаден за живот в града, съчетаващ
          динамика, модерни технологии и впечатляваща функционалност. С функция
          за бързо зареждане и иновативна ефективност, той ви позволява да
          намалите разходите за поддръжка и да се насладите на икономично и
          устойчиво пътуване.
        </p>
      </section>

      <section className="w-full px-8 py-12 bg-white">
        <div className="grid grid-cols-1 gap-12 px-6 md:grid-cols-2">
          {/* Колона 1 */}
          <div className="text-left">
            <img
              src="/images/puma-gen-e/ford-puma-gen-e-profile.jpeg"
              alt="Ford Puma Gen-E Feature 1"
              className="w-full h-auto mb-6 rounded"
            />
            <h2 className="mb-2 text-4xl tracking-wider font-fordMedium text-fordBlue">
              Ford Puma Gen-E
            </h2>
            <p className="tracking-wider text-fordBlue">
              Готов за пътя със 17&quot; алуминиеви джанти, амбиентно
              осветление, навигация и вграден високоскоростен 5G модем.
            </p>
          </div>
          {/* Колона 2 */}
          <div className="text-left">
            <img
              src="/images/puma-gen-e/ford-puma-gen-e-premium-profile.jpeg"
              alt="Ford Puma Gen-E Feature 2"
              className="w-full h-auto mb-6 rounded"
            />
            <h2 className="mb-2 text-4xl tracking-wider font-fordMedium text-fordBlue">
              Ford Puma Gen-E Premium
            </h2>
            <p className="tracking-wider text-fordBlue">
              Подобрете стила си с алуминиеви джанти до 19", Matrix LED фарове и
              аудиосистема B&O с интегриран саундбар.
            </p>
          </div>
        </div>
      </section>

      <section className="p-16 tracking-wider bg-gray-100 text-fordBlue">
        <h3 className="font-fordBold">Панорамен покрив</h3>
        <p>
          Небето е границата - Опционалният панорамен покрив залива вашия Puma
          Gen‑E® с естествена светлина, създавайки усещане за простор и свобода.
          Насладете се на пътуването, докато пътниците се възхищават на света
          около вас.
        </p>
      </section>

      <section className="w-full px-8 py-12 bg-white">
        <div className="grid items-start grid-cols-1 gap-12 md:grid-cols-2">
          {/* Лява колона - снимка */}
          <div>
            <img
              src="https://ford-cdn.fsn1.your-objectstorage.com/6s972x2xzh0b6fu8e7fne0quhze3"
              alt="Амбиентно осветление в Puma Gen-E"
              className="w-full h-auto rounded-xl"
            />
          </div>
          {/* Дясна колона - текст */}
          <div className="flex flex-col justify-start text-left">
            <h2 className="mb-4 text-3xl tracking-wider font-fordMedium text-fordBlue">
              АМБИЕНТНО ОСВЕТЛЕНИЕ
            </h2>
            <p className="tracking-wider text-fordBlue">
              Създайте перфектната атмосфера. Изберете своя стил – от игриво и
              динамично до елегантно и мощно, с персонализирано и многоцветно
              вътрешно осветление.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-8 bg-white">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          {/* Колона 1 */}
          <div className="text-left">
            <img
              src="https://ford-cdn.fsn1.your-objectstorage.com/nig15xc6hoztglt2vgovwm4mfxgp"
              alt="Интериор Ford Puma Gen-E"
              className="w-full h-auto mb-6 rounded-xl"
            />
            <h2 className="mb-2 text-3xl tracking-wider font-fordMedium text-fordBlue">
              ИНТУИТИВЕН ДИЗАЙН
            </h2>
            <p className="tracking-wider text-fordBlue">
              Преработената централна конзола поставя всичко на лесно достъпно
              място, а регулируемият подлакътник осигурява оптимален комфорт.
            </p>
          </div>
          {/* Колона 2 */}
          <div className="text-left">
            <img
              src="https://ford-cdn.fsn1.your-objectstorage.com/g8nwgua7xexkswus9vef41ttp9h8"
              alt="Инфотейнмънт Ford Puma Gen-E"
              className="w-full h-auto mb-6 rounded-xl"
            />
            <h2 className="mb-2 text-3xl tracking-wider font-fordMedium text-fordBlue">
              ПРЕМИУМ КОМФОРТ
            </h2>
            <p className="tracking-wider text-fordBlue">
              Насладете се на комфорт благодарение на седалките с ергономични
              подглавници и луксозни, стилни акценти.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full mt-24 aspect-video">
        <div className="w-full mt-24 aspect-video">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/KFTlJqpb5sk?autoplay=1&mute=1&controls=0&rel=0&playsinline=1&loop=1&playlist=KFTlJqpb5sk"
            title="Puma Gen-E видео 2"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      <section className="w-full mt-24 bg-white">
        <img
          src="https://ford-cdn.fsn1.your-objectstorage.com/k5fljwsuc0rgs2xo2u073o7grduw"
          alt="Персонализирано багажно пространство"
          className="object-cover w-full h-72"
        />
        <div className="px-6 py-12 text-center text-fordBlue">
          <h2 className="mb-4 text-3xl tracking-wider uppercase font-fordMedium">
            Персонализирано багажно пространство
          </h2>
          <p className="max-w-4xl mx-auto tracking-wider">
            С регулируемия под на багажното отделение можете да използвате
            пълния му капацитет от 523 литра, или да го разделите, за да
            подредите и осигурите безопасно съхранение на предметите.
          </p>
        </div>
      </section>

      <motion.section
        id="poiskayOferta"
        className="w-full py-8 mx-auto bg-gray-100"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 1.3 }}
      >
        {renderContactForm()}
      </motion.section>

      <p className="px-2 mt-16 text-sm text-center text-gray-500">
        * Цената е валидна за модел Ford Puma Gen-E с предно предаване (FWD),
        електрически двигател с мощност 168 к.с. и батерия с капацитет 44 kWh.
      </p>
    </>
  );
}

export default PumaGenE;
